export const editMutations = <const>{
	ND_PRINVOICE_SELECT_MAPPER: 'ND_PRIJEMKA_PR_INVOICE_SELECT_MAPPER',
	PRINVOICE_INVOICE_SELECT_MAPPER: 'PRINVOICE_INVOICE_SELECT_MAPPER',
	ND_PRIJEMKA_DODAVATEL_SELECT_MAPPER: 'ND_PRIJEMKA_DODAVATEL_SELECT_MAPPER',
};
export const listMutations = <const>{
	ND_PRIJEMKA_DODAVATEL_FILTER_SELECT_MAPPER: 'ND_PRIJEMKA_DODAVATEL_FILTER_SELECT_MAPPER',
	ND_PRIJEMKA_STATUS_PRIJEMKY: 'ND_PRIJEMKA_STATUS_PRIJEMKY',
	ND_PRIJEMKA_FILTER_PRORDERS_SELECT_MAPPER: 'ND_PRIJEMKA_FILTER_PRORDERS_SELECT_MAPPER',
};
export const types = <const>{
	mutations: {
		COMPUTE_ROWS_HASH: 'COMPUTE_ROWS_HASH',
	},
};
